// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'publicAFList/applySearchFilter'
export const HIDE_LIST_ALERT = 'pubicAFList/hideAlert'
export const SET_LIST_ALERT = 'publicAFList/setAlertModal'
export const IS_LOADING = 'publicAFList/isLoading'
export const SET_CONFIRM_MODAL = 'publicAFList/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'publicAFList/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'publicAFList/showConfirmModal'
export const RESET_FILTERS = 'publicAFList/reset'
export const RESET_RESULTS = 'publicAFList/resetTableData'
export const UPDATE_SEARCHLIST = 'publicAFList/updateResults'
export const CHG_FILTER_DATA = 'publicAFList/changeFilterField'
export const CHG_FILTER_PAGE = 'publicAFList/changePage'
export const CHG_FILTER_PAGE_SIZE = 'publicAFList/changePageSize'
export const CHG_FILTER_SORT = 'publicAFList/changeSortModel'
export const CHG_SELECTED_ROWS = 'publicAFList/changeSelected'
export const UPD_LIST_ALERT = 'publicAFList/updateAlert'

// ADD FORM TYPES
export const RESET_ADD_DATA = 'publicAFAdd/reset'
export const UPD_ADD_ALERT = 'publicAFAdd/updateAlert'
export const INSERT_LOADING = 'publicAFAdd/isLoading'
export const CHG_FIELD = 'publicAFAdd/changeField'
export const CHG_STATUS = 'publicAFAdd/changeStatus'
export const SET_ADD_DATA = 'publicAFAdd/setAddData'
export const HIDE_ADD_ALERT = 'publicAFAdd/hideAlert'
export const CHG_APPLICANT_ID = 'publicAFAdd/changeApplicantId'
export const SHW_LEGAL_MODAL = 'publicAFAdd/showLegalModal'
export const HIDE_MODAL = 'publicAFAdd/hideModal'
export const SHW_FILE_MODAL = 'publicAFAdd/showFileUploadModal'
export const CHG_FILE_UPLD = 'publicAFAdd/changeFileUpload'
export const CHG_AGE_DATA = 'publicAFAdd/changeAddData'
export const SET_ADD_EMAIL_TEMPLATE = 'publicAFAdd/setAddEmailTemplate'

// DETAIL TYPES
export const UPD_DETAIL_TITLE = 'publicAFDetails/changeTitle'
export const CHG_DETAIL_DATA = 'publicAFDetails/changeFieldData'
export const UPD_DETAIL_MODE = 'publicAFDetails/changeMode'
export const HAS_DETAIL_LOADED = 'publicAFDetails/hasDetailLoaded'
export const SET_DETAIL_DATA = 'publicAFDetails/setDetailData'
export const UPD_DETAIL_DATA = 'publicAFDetails/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'publicAFDetails/setConfirmModel'
export const HIDE_DETAIL_CONFIRM_MODAL = 'publicAFDetails/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'publicAFDetails/showConfirmModal'
export const SET_DETAIL_ALERT = 'publicAFDetails/showConfirmModal'
export const HIDE_DETAIL_ALERT = 'publicAFDetails/hideAlert'
export const SET_ATTACHMENT_DATA = 'publicAFDetails/setAttachmentData'
export const CHG_UPLD_FILE = 'publicAFDetails/changeFileUpload'
export const SHW_MODAL_FILE = 'publicAFDetails/showFileUploadModal'
export const HIDE_MODAL_FILE = 'publicAFDetails/hideFileUploadModal'
export const SET_DETAIL_EMAIL_TEMPLATE = 'publicAFDetails/setDetailEmailTemplate'